<template>
	<button 
		class="flex font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-1 px-3.5 border-2 border-primary-700 text-primary-700 text-base rounded hover:shadow-button hover:text-primary-800 hover:border-primary-800 focus:text-primary-900 focus:border-primary-900 focus:shadow-none active:text-primary-900 active:border-primary-900 active:shadow-none disabled:text-grays-600 disabled:shadow-none disabled:border-grays-400"
		:class="[
			(container ? 'w-[300px] flex-none' : ''), 
			(small ? 'py-0 px-4' : '')
		]"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: "button-tertiary",
	props: {
		container: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		}
	},
}
</script>

<style>

</style>